import { useMutation } from "@tanstack/react-query";
import { fetchWithErrorHandling } from "../utils/service";

/**
 * "Ask your bookmarks" — send a question, get a cited answer synthesized from
 * the user's own bookmarks. Returns { pro, found, answer, sources }.
 */
export const useAsk = () =>
  useMutation({
    mutationFn: async (question) =>
      (
        await fetchWithErrorHandling("/v1/search/ask", {
          method: "POST",
          body: JSON.stringify({ question }),
        })
      ).data,
  });
